module.exports = __webpack_public_path__ + "static/media/Blade_PinchTabArm.e7db8585.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/wiper-blades-adapters/Blade_PinchTabArm.jpg
// module id = 297
// module chunks = 0